import React from 'react';

const TermsAndConditions = () => {
    return (
        <div className="container mt-5">
            <h1 className="text-center">Terms and Conditions ("Terms of Use") for Clients of Alborz Payment Canada Inc.</h1>
            <p>
                These Terms of Use set forth the terms and conditions governing the services ("Services") provided by Alborz Payment Canada Inc. ("Alborz Payment", "we", "us", or "our").
            </p>
            <p>
                By registering for or using an Alborz Payment account ("Account") or otherwise using the Services, you ("you", "your", or "user") agree to be bound by these Terms of Use, and to receive communications related to your use of the Services or your Account. If you do not accept these Terms of Use or our Privacy Policy, you may not use the Services.
            </p>
            <p>
                We recommend that you print a copy of these Terms of Use for your reference.
            </p>

            <section>
                <h2>1. Company Information</h2>
                <p>
                    Alborz Payment is registered as a Money Services Business (MSB) with the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC), registration number M20486691. We provide foreign exchange and money transfer services to customers in Canada. We do not act as a payment processor, bank, or other financial institution. We do not accept cash or cryptocurrency under any circumstances.
                </p>
            </section>

            <section>
                <h2>2. Eligibility</h2>
                <p>
                    You must be at least 18 years old or the age of majority in your province or territory of residence to use the Services. You represent that you are acting on your own behalf and not for any third party. Accounts must only be used by the registered individual. Sharing login credentials is strictly prohibited and may result in account suspension.
                </p>
            </section>

            <section>
                <h2>3. Prohibited Activities</h2>
                <p>You may not use the Services for activities that:</p>
                <ul>
                    <li>Violate any law, statute, ordinance, or regulation.</li>
                    <li>Involve entities subject to sanctions or asset freezes.</li>
                    <li>Involve high-tech, nuclear, or missile programs.</li>
                    <li>Involve obscene materials, controlled substances, or drug paraphernalia.</li>
                    <li>Are identified as fraudulent by government authorities.</li>
                </ul>
            </section>

            <section>
                <h2>4. Opening and Maintaining an Account</h2>
                <p>
                    You must provide accurate and complete information during registration and update it as necessary. We reserve the right to suspend or terminate Services to any user at our sole discretion.
                </p>
                <h3>4.1 Account Security</h3>
                <p>
                    You are solely responsible for maintaining the confidentiality of your login credentials. Alborz Payment will never request your password by email, phone, or text. Report any suspicious activity immediately to our Customer Support at +1 (647) 745-4666.
                </p>
                <h3>4.2 Duplicate Accounts</h3>
                <p>
                    We reserve the right to close or merge duplicate accounts without notice.
                </p>
                <h3>4.3 Verification</h3>
                <p>
                    You authorize us to verify your identity using internal or third-party sources. We may request certified photo ID and bank account ownership verification. Failure to comply may result in account restriction.
                </p>
            </section>

            <section>
                <h2>5. Deposits and Funding</h2>
                <p>
                    You may deposit funds through Interac e-transfer or any other available payment gateway. We do not guarantee the availability of any deposit method.
                </p>
                <h3>5.1 Bank Account Funding</h3>
                <p>
                    You confirm you are authorized to initiate Interac e-transfer transactions and that all information provided is accurate.
                </p>
                <h3>5.2 Gateway Funding</h3>
                <p>
                    Transactions via third-party gateways must be completed through the gateway interface. Funds are credited once received by Alborz Payment.
                </p>
            </section>

            <section>
                <h2>6. Account Balances</h2>
                <h3>6.1 Non-Bank Status</h3>
                <p>
                    Your Alborz Payment Account is not a bank account. Funds are not CDIC-insured. Balances must not exceed $10.00 CAD and should be used or withdrawn within 24 hours. No interest is paid on balances.
                </p>
                <h3>6.2 Transaction History</h3>
                <p>
                    You can access your full transaction history by logging into your Account.
                </p>
                <h3>6.3 Currency Holdings</h3>
                <p>
                    Holding multiple currencies may expose you to volatility. Currency arbitrage and speculation are prohibited.
                </p>
            </section>

            <section>
                <h2>7. Sending or Withdrawing Money</h2>
                <p>
                    You may transfer funds to your bank, another user, or close your Account and withdraw the balance. Not all methods are available to all users. Fees apply and are shown upfront. All transactions are subject to applicable limits and clearing times.
                </p>
            </section>

            <section>
                <h2>8. Currency Conversion</h2>
                <p>
                    We apply conversion fees to foreign exchange transactions. Rates are based on market conditions and shown before each transaction. We reserve the right to refuse any currency conversion.
                </p>
            </section>

            <section>
                <h2>9. Fees and Taxes</h2>
                <p>
                    All fees are displayed upfront. Users are responsible for bank fees and compliance with applicable tax laws.
                </p>
            </section>

            <section>
                <h2>10. Closing Your Account</h2>
                <h3>10.1 By Customer</h3>
                <p>
                    You may close your Account at any time by contacting Customer Support. Your data will be retained for a minimum of 7 years. You remain responsible for any pending or disputed transactions.
                </p>
                <h3>10.2 By Alborz Payment</h3>
                <p>
                    We may suspend or terminate your Account at any time, with or without notice. Reasons include but are not limited to: violation of these Terms, regulatory requests, suspected fraud, unauthorized access, or duplicate accounts.
                </p>
            </section>

            <section>
                <h2>11. Communications</h2>
                <p>
                    You agree to receive communications by email, SMS, phone, mail, or website notices. We are not liable for fees charged by your service providers.
                </p>
            </section>

            <section>
                <h2>12. Errors and Unauthorized Transactions</h2>
                <p>
                    You are responsible for reviewing your transaction history and reporting unauthorized activity. We are not liable for losses resulting from your failure to secure your credentials.
                </p>
            </section>

            <section>
                <h2>13. Chargebacks and Negative Balances</h2>
                <p>
                    You are responsible for any chargebacks, reversals, or resulting negative balances. Negative balances must be repaid within 14 days. We may pursue collections or legal action.
                </p>
            </section>

            <section>
                <h2>14. Complaints</h2>
                <p>
                    To file a complaint, email <a href="mailto:contact@alborzpayment.com">contact@alborzpayment.com</a> or call +1 (647) 745-4666.
                </p>
            </section>

            <section>
                <h2>15. Technology and Website Use</h2>
                <h3>15.1 Linking</h3>
                <ul>
                    <li>The link is fair and does not damage our reputation.</li>
                    <li>You do not falsely suggest endorsement.</li>
                    <li>You do not frame our website.</li>
                    <li>You do not impersonate us or use our materials without consent.</li>
                </ul>
                <h3>15.2 Security</h3>
                <p>
                    You must protect your systems and not misuse ours. Any attempt to compromise or attack our systems will be reported to law enforcement.
                </p>
                <h3>15.3 Third Parties</h3>
                <p>
                    We may rely on third parties to provide certain Services. Your information may be shared with them under our Privacy Policy. We are not liable for the accuracy or reliability of third-party services.
                </p>
            </section>

            <section>
                <h2>16. Limitation of Liability</h2>
                <p>
                    Alborz Payment shall only be liable to the extent required by applicable law. We are not liable for indirect or consequential damages, including loss of profits or data. Our total liability is limited to the amount of direct damages permitted by law.
                </p>
            </section>

            <section>
                <h2>17. Service Availability</h2>
                <p>
                    We strive to maintain service availability but do not guarantee uninterrupted access. We may suspend or modify Services without notice.
                </p>
            </section>

            <section>
                <h2>18. No Warranty</h2>
                <p>
                    The Services are provided "as is" without warranties of any kind.
                </p>
            </section>

            <section>
                <h2>19. Force Majeure</h2>
                <p>
                    We are not liable for delays or failure due to events beyond our control.
                </p>
            </section>

            <section>
                <h2>20. Intellectual Property</h2>
                <p>
                    All trademarks, logos, and materials associated with Alborz Payment are protected. Unauthorized use may result in legal action.
                </p>
            </section>

            <section>
                <h2>21. Relationship</h2>
                <p>
                    We act as an independent contractor, not your agent or trustee.
                </p>
            </section>

            <section>
                <h2>22. Entire Agreement</h2>
                <p>
                    These Terms of Use, the Privacy Policy, and other posted terms form the entire agreement between you and Alborz Payment. Continued use of the Services constitutes acceptance of any future amendments.
                </p>
            </section>

            <section>
                <h2>23. Governing Law</h2>
                <p>
                    These Terms are governed by the laws of Ontario, British Columbia, and applicable federal laws of Canada.
                </p>
            </section>

            <section>
                <h2>24. Language</h2>
                <p>
                    These Terms are written in English, and all related communications will be conducted in English.
                </p>
            </section>

        </div>
    );
};

export default TermsAndConditions;